import { newPathFor } from '@/designs-dev/loft/projects';

// Where the magic-capture prototype is mounted, and how its own in-prototype
// paths map onto that.
//
// It used to run a MemoryRouter so its journey could navigate without touching
// the app's URL. React Router refuses to render a Router inside a Router, and
// the app has a BrowserRouter at its root, so the page was a white screen with
// "You cannot render a <Router> inside another <Router>" in the console. It has
// been that way since the prototype was moved under components/, which is long
// enough that nobody had opened it.
//
// So it uses the app's router now, mounted under a splat, and keeps writing its
// own paths ('/care', '/capture/result') everywhere. These translate.
const base = () => newPathFor('/magic-capture') ?? '';

/** An in-prototype path, as an app path. */
export const at = (path: string): string =>
  `${base()}${path === '/' ? '' : path}`;

/** An app path, back to the in-prototype one, for active-tab comparisons. */
export const within = (pathname: string): string =>
  pathname.startsWith(base()) ? pathname.slice(base().length) || '/' : pathname;
